<template>
    <button type="button" id="statementBtn" class="btn-i" :class="checkboxVisible ? 'btn-l btn-p': 'btn-m'" @click="runDownloadInvoice">
        <span>전자거래명세서</span>
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 16.5h10M6 1.5v11.667M10.167 9l-4.166 4.167L1.834 9" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            :filename="createPdfFileName"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div class="pdf">
                    <table class="invoice-table">
                        <thead>
                            <tr>
                                <th colspan="4" class="caption">
                                    <h3>예스콘 전자거래명세서</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="row01">
                                <th class="width-base">거 래 기 간</th>
                                <td class="width-long">{{startOrderDate}} ~ {{endOrderDate}}</td>
                                <th class="width-base">작 성 일 자</th>
                                <td class="width-long">{{createdDate}}</td>
                            </tr>
                            <tr class="row02">
                                <td colspan="2" class="has-table">
                                    <table class="width-full height-full">
                                        <tr class="border-t-none border-l-none">
                                            <th rowspan="2" class="width-mini1">공<br>급<br>받<br>는<br>자</th>
                                            <th class="width-mini2">등 록 번 호</th>
                                            <td colspan="3" class="width-long border-r-none">{{this.companyRegnum}}</td>
                                        </tr>
                                        <tr>
                                            <th class="width-mini2">상 호</th>
                                            <td>{{this.companyName}}</td>
                                            <th class="width-mini2">성 명</th>
                                            <td class="border-r-none">{{this.ceoName}}</td>
                                        </tr>
                                    </table>
                                </td>
                                <td colspan="2" class="has-table">
                                    <table class="width-full height-full">
                                        <tr class="border-t-none border-l-none">
                                            <th rowspan="2" class="width-mini1 border-l-none">공<br>급<br>자</th>
                                            <th class="width-mini2">등 록 번 호</th>
                                            <td colspan="3" class="width-long border-r-none">220-81-54389</td>
                                        </tr>
                                        <tr>
                                            <th class="width-mini2">상 호</th>
                                            <td>주식회사 <br>티사이언티픽</td>
                                            <th class="width-mini2">성 명</th>
                                            <td class="border-r-none">김상우 <br>유승재</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr class="row03">
                                <td colspan="4" class="has-table">
                                    <table class="width-full">
                                        <tr class="border-t-none border-l-none">
                                            <th class="width-base">거 래 일</th>
                                            <th class="width-long">품 명</th>
                                            <th class="width-mini2">수 량</th>
                                            <th class="width-mini2">단 가</th>
                                            <th class="width-mini2">할 인 금 액</th>
                                            <th class="width-mini2">주 문 금 액</th>
                                            <th class="width-mini2 border-r-none">최 종 금 액</th>
                                        </tr>
                                        <tr v-for = "(row, rowNum) in pdfDownloadInfoList" :key="rowNum">
                                            <td>{{row.orderDate}}</td>
                                            <td>{{row.goodsNm}}</td>
                                            <td>
                                                <template v-if="row.subOrderStatus === '부분취소'">
                                                    {{row.successCnt}}
                                                </template>
                                                <template v-else>
                                                    {{row.orderCnt}}
                                                </template>
                                            </td>
                                            <td>{{Number(row.goodsPriceMarket).toLocaleString()}}</td>
                                            <td>{{Number(row.perDiscountPrice).toLocaleString()}}</td>
                                            <td>{{Number(row.perGoodsPricePoc).toLocaleString()}}</td>
                                            <td class="border-r-none">
                                                <template v-if="row.subOrderStatus === '부분취소'">
                                                    {{Number(row.perGoodsPricePoc * row.successCnt).toLocaleString()}}
                                                </template>
                                                <template v-else>
                                                    {{Number(row.perGoodsPricePoc * row.orderCnt).toLocaleString()}}
                                                </template>    
                                            </td>
                                        </tr>
                                        <tr class="border-l-none border-b-none">
                                            <th colspan="2">소 계</th>
                                            <td>{{totalOrderCnt}}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="border-r-none">{{Number(totalResultPayPrice).toLocaleString()}}</td>
                                        </tr>
                                    </table>
                                </td>                
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>비 고</th>
                                <td>모바일교환권은 계산서 발행/신고 제외 대상</td>
                                <th>공 급 가</th>
                                <td>{{Number(totalResultPayPrice).toLocaleString()}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </section>
        </vue-html2pdf>
    </button>
</template>

<script>
import { mapState } from 'vuex';
import { getNowDate } from '@/util';
import VueHtml2pdf from 'vue-html2pdf';
export default {
    components: {
        VueHtml2pdf
    },

    props: {
        checkboxVisible: {      // 주문 아이템 체크박스 노출 여부
            type: Boolean,
            default: false,
        },
    },

    data(){
        return{
            companyName:'',
            companyRegnum:'',
            ceoName:'',
            pdfDownloadInfoList:[]
        }
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexExcelOrderHistoryList: state => state.orderHistoryStore.vuexExcelOrderHistoryList
        }),

        // 총 수량
        totalOrderCnt(){
            let calOrderCnt = 0;
            for(let i = 0; i < this.pdfDownloadInfoList.length; i++) {
                if(this.pdfDownloadInfoList[i].subOrderStatus === '부분취소') {
                    calOrderCnt += Number(this.pdfDownloadInfoList[i].successCnt);    
                } else {
                    calOrderCnt += Number(this.pdfDownloadInfoList[i].orderCnt);
                }
                
            }
            return calOrderCnt;
        },

        //총 최종금액
        totalResultPayPrice(){
            let calResultPayPrice = 0;
            for(let i = 0; i < this.pdfDownloadInfoList.length; i++) {
                if(this.pdfDownloadInfoList[i].subOrderStatus === '부분취소') {
                    calResultPayPrice += Number(this.pdfDownloadInfoList[i].perGoodsPricePoc) * Number(this.pdfDownloadInfoList[i].successCnt);
                } else {
                    calResultPayPrice += Number(this.pdfDownloadInfoList[i].perGoodsPricePoc) * Number(this.pdfDownloadInfoList[i].orderCnt);
                }
                
            }
            return calResultPayPrice;
        },

        // 거래기간 시작기간
        startOrderDate(){
            let result = null;
            if(Array.isArray(this.pdfDownloadInfoList) && this.pdfDownloadInfoList.length !== 0) {
                result = this.pdfDownloadInfoList[this.pdfDownloadInfoList.length - 1].orderDate;
            }
            return result;
        },

        // 거래기간 종료기간
        endOrderDate(){
            let result = null;
            if(Array.isArray(this.pdfDownloadInfoList) && this.pdfDownloadInfoList.length !== 0) {
                result = this.pdfDownloadInfoList[0].orderDate;
            }
            return result;
        },

        // 작성일자
        createdDate() {            
            let date = new Date();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            let min = date.getMinutes();

            month = month >= 10 ? month : '0' + month;
            day = day >= 10 ? day : '0' + day;
            hour = hour >= 10 ? hour : '0' + hour;
            min = min >= 10 ? min : '0' + min;

            return date.getFullYear() + '.' + month + '.' + day + ' ' + hour + ':' + min;
        },

        // 명세서 파일명 생성
        createPdfFileName() {
            let pdfTitleResult = getNowDate() +'_'+ '예스콘명세서';
            return pdfTitleResult;
        }
    },

    methods:{
        // 전자거래명세서 버튼 클릭 
        runDownloadInvoice(){
            this.$forceUpdate();
            this.getCompany();
        },

        getCompany() {
            this.dispatchFindCompanyInfo();
        },

        async dispatchFindCompanyInfo() {
            try {
                const response = await this.$store.dispatch(
                    'userStore/acitonsFindCompanyInfoApi'
                );

                this.companyName = response.data.companyName;
                this.companyRegnum = this.convertCompanyRegnum(response.data.companyRegnum);
                this.ceoName = response.data.ceoName;
                this.downloadInvoicePdf();
            } catch(err) {
                alert(err.response.data.message);
                return;
            }
        },

        downloadInvoicePdf() {
            if(this.companyRegnum === 'YESCON') { // 사업자등록번호 미입력일 경우 회원정보 수정페이지로 이동
                if (!confirm('회원정보에 사업자등록번호를 입력하지 않은 경우 전자거래명세서를 출력할 수 없습니다. \n회원정보에 사업자등록번호를 추가하시겠습니까?')) {
                    // 취소(아니오) 버튼 클릭 시 이벤트
                    return;
                } else {        
                    // 확인(예) 버튼 클릭 시 이벤트
                    this.$router.push("/account/profile-info");
                }
            } else {
                if(this.vuexExcelOrderHistoryList.length > 0) {
                    if(this.checkOrderCancel()){
                        if (!confirm('체크된 항목 중에 취소내역 건이 있습니다.\n취소내역 건은 제외되어 출력됩니다.')) {
                            // 취소(아니오) 버튼 클릭 시 이벤트
                            return;
                        } else {
                            // 확인(예) 버튼 클릭 시 이벤트
                            this.exceptOrderCancel();        
                            // pdf 다운로드
                            this.$refs.html2Pdf.generatePdf();
                        }
                    } else {
                        // pdf 다운로드
                        this.pdfDownloadInfoList = Array.from(this.vuexExcelOrderHistoryList); 
                        this.$refs.html2Pdf.generatePdf();
                    }
                } else {
                    alert('항목을 선택하여 주십시오');
                }
            }
        },

        exceptOrderCancel() {
            let result = null;
            let tempvuexExcelOrderHistoryList = Array.from(this.vuexExcelOrderHistoryList);
            
            result = tempvuexExcelOrderHistoryList.filter((item) => item.orderStatus !== '주문취소');
            
            this.pdfDownloadInfoList = result;
        },

        checkOrderCancel() {
            return this.vuexExcelOrderHistoryList.some((item) =>  Number(item.cancelCnt) !== 0);
        },

        convertCompanyRegnum(companyRegnum) {
            if(companyRegnum !== 'YESCON') {
                return companyRegnum.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
            } else {
                return companyRegnum
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util/pdf.scss';

</style>